/* --------------------------------------------------------------------------
	Media Gallery
-------------------------------------------------------------------------- */

	"use strict";
	var $ = jQuery;
	import '../base/swap.js';
	
    var $Dialog,
		$DialogDocument,
		$DialogTrigger,
		$Trigger,
		$Target,
		$DialogClose;

	function initMediaGallery() {
		$Dialog = $(".js-media-gallery-dialog");
		if ($Dialog.length) {
			$DialogDocument = $(".js-media-gallery-dialog-document");
			$DialogTrigger = $(".js-media-gallery-dialog-trigger");
			$DialogClose = $(".js-media-gallery-dialog-close");

			bindUI();
			setup();
		}
    }
    
    function bindUI() {
		$DialogTrigger
			.on("activate.swap", onTriggerActivate)
			.on("deactivate.swap", onTriggerDeactivate);
		$DialogClose
			.on("click", onCloseClick)
			.on("keydown", onCloseKeydown);
		$Dialog
			.on("keydown", onDialogKeydown)
			.on("keyup", onDialogKeyup);
	}

	function setup() {
		$Dialog
			.attr({
				"role": "dialog",
				"aria-modal": "true",
				"aria-hidden": "true",
				"tabindex": "0"
			});

		$DialogDocument.attr("role", "document");

		$DialogTrigger.attr("role", "button");
	}

	function onTriggerActivate() {
		$Trigger = $(this);
		$Target = $($(this).data("swap-target"));

		openDialog();
	}

	function onTriggerDeactivate() {
		closeDialog();
	}

	function onCloseClick(e) {
		$Trigger.swap("deactivate");
	}

	function onCloseKeydown(e) {
		if (e.keyCode === 9) { // tab
			if (!(e.shiftKey)) {
				$Target.focus();
			}
		}
	}

	function onDialogKeydown(e) {
		if ($Dialog.is(":focus")) {
			if (e.keyCode === 9) { // tab
				if (e.shiftKey) {
					e.preventDefault();

					$Target
						.find(".js-dialog-close")
						.focus();
				}
			}
		}
	}

	function onDialogKeyup(e) {
		if (e.keyCode === 27) { // escape
			$Trigger.swap("deactivate");
		}
	}

	function onDocumentClick(e) {
		if ($("body").hasClass("dialog_open")) {
			if (!($(e.target).closest(".js-media-gallery-dialog").length || $(escape.target).closest(".js-media-gallery-dialog-trigger").length)) {
				$Trigger.swap("deactivate");
			}
		}
	}

	function openDialog() {
		$("html, body").addClass("dialog_open").animate({
			// scrollTop: $Dialog.offset().top
			scrollTop: 0
		}, 0);

		//scroll to top

		$Target
			.attr("aria-hidden", "false")
			.focus();
	}

	function closeDialog() {
		$("html, body").removeClass("dialog_open");

		pauseVideos();

		$Target.attr("aria-hidden", "true");
		$Trigger.focus();
	}

	function pauseVideos() {
		$(".js-video-item-youtube").each(function() {
			$(this)[0].contentWindow.postMessage('{"event": "command", "func": "pauseVideo", "args": ""}', '*');
		});

		$(".js-video-item-vimeo").each(function() {
			$(this)[0].contentWindow.postMessage({
				"method": "pause"
			}, $(this)[0].src);
		});
    }

	$(initMediaGallery);
